import { SocketClient } from "cbcore-ts"
import { UIView } from "uicore-ts"
import { formatRHDateTime } from "./Custom components/RH/Utils_slop/RHDateFormatting"
import { RHNavbar } from "./Custom components/RH/Utils_slop/RHDesignTokens"


export class BottomBarView extends UIView {
    
    //label: UITextView;
    
    constructor(elementID: string) {
        
        super(elementID)
    
        // this.backgroundColor = UIColor.colorWithRGBA(50, 50, 50)
        this.backgroundColor = RHNavbar.bottomBarBackgroundColor
        
        this.setInnerHTML("bottomBarContent", "bottomBarContent", { UPDATE_TIME_STRING: "" })
        
        this.loadUpdateTimeString()
        
        // this.label = new UITextView("BottomBarLabel");
        // this.label.setText("bottomBarLabelText","Bottom bar for contact information and such");
        // this.label.textColor = UIColor.whiteColor;
        // this.label.textAlignment = UITextView.textAlignment.center;
    
        // this.addSubview(this.label);
        
    }
    
    
    async loadUpdateTimeString() {
        
        const date = new Date(
            (await SocketClient.RetrieveLastUpdateTimestamp()).result
        )
        
        const formattedString = formatRHDateTime(date)
        
        this.setInnerHTML(
            "bottomBarContent",
            "bottomBarContent",
            { UPDATE_TIME_STRING: "<br>\n Andmed viimati uuendatud: " + formattedString }
        )
        
        
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        //this.label.centerInContainer();
        
    }
    
}






















